/**
 * @fileoverview Hook to fetch enabled speed dial items for rendering the
 * floating speed dial navigation component.
 */

import { useEffect, useState } from 'react';
import { apiClient } from '@/api';
import type { SpeedDialItem } from '@schema';

interface UseSpeedDialItemsReturn {
  items: SpeedDialItem[];
  loading: boolean;
}

export function useSpeedDialItems(): UseSpeedDialItemsReturn {
  const [items, setItems] = useState<SpeedDialItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    async function fetchItems() {
      try {
        const result = await apiClient.getMany<SpeedDialItem>('speed_dial_item', {
          page: '0',
          pageSize: '50',
          sortField: 'display_order',
          sortOrder: 'asc',
        });
        if (cancelled) return;
        const enabled = result.items.filter((item) => item.is_enabled);
        setItems(enabled);
      } catch (error) {
        if (!cancelled) {
          console.error('Failed to fetch speed dial items:', error);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }
    void fetchItems();
    return () => {
      cancelled = true;
    };
  }, []);

  return { items, loading };
}

